import styled from 'styled-components';
import { Radio } from 'opencare-crown';
import { colors, BREAKPOINTS } from 'common/styles/style-constants';

export const SelectButton = styled(Radio.Button)`
  && {
    height: auto;
    padding: 15px 0px;
    text-align: center;
    width: 50%;
    border-radius: ${props => props.border} !important;

    > span {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    > .ant-radio-button {
      height: auto;
    }

    &.ant-radio-button-wrapper {
      cursor: pointer;
    }

    &.ant-radio-button-wrapper:first-child {
      border-radius: 10px 0 0 10px;
    }

    &.ant-radio-button-wrapper:last-child {
      border-radius: 0 10px 10px 0;
    }

    &.ant-radio-button-wrapper:not(.ant-radio-button-wrapper-disabled) {
      &:hover {
        color: ${colors.blue};
      }
    }
    &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
      background: ${colors.blue};
      border-color: ${colors.blue};
      box-shadow: none;
      color: ${colors.white};
      font-weight: 600;
      &:active {
        background: ${colors.blue};
        border-color: ${colors.blue};
        box-shadow: none;
        color: ${colors.white};
      }
      &:hover {
        background: ${colors.blue};
        border-color: ${colors.blue};
        box-shadow: none;
        color: ${colors.white};
      }
    }
    @media (max-width: ${BREAKPOINTS.mobileMax}px) {
      padding: 8px 0;
    }
  }
`;
